import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LayoutDashboard, CalendarDays, Users, Handshake, Inbox, LogOut, ExternalLink, Settings, Image as ImageIcon, ShieldCheck } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/admin", label: "Overzicht", icon: LayoutDashboard, end: true },
  { to: "/admin/events", label: "Events", icon: CalendarDays },
  { to: "/admin/team", label: "Team", icon: Users },
  { to: "/admin/partners", label: "Partners", icon: Handshake },
  { to: "/admin/galerij", label: "Galerij", icon: ImageIcon },
  { to: "/admin/inzendingen", label: "Inzendingen", icon: Inbox },
  { to: "/admin/instellingen", label: "Instellingen", icon: Settings },
  { to: "/admin/privacy", label: "Privacybeleid", icon: ShieldCheck },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen flex bg-[#F4F5F7]" style={{ fontFamily: "'Outfit', sans-serif" }}>
      <aside className="w-64 shrink-0 bg-white border-r border-[#E2E8F0] flex flex-col fixed h-screen">
        <div className="p-6 border-b border-[#E2E8F0]">
          <div className="flex items-center gap-2.5">
            <img src="/elsa-logo-navy.png" alt="ELSA Brussel" className="h-9 w-auto object-contain" />
            <span className="text-[11px] font-600 uppercase tracking-widest text-[#666666] border-l border-[#E2E8F0] pl-2.5">Admin</span>
          </div>
        </div>
        <nav className="flex-1 p-4 space-y-1">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm transition-colors ${
                  isActive ? "bg-[#0A3087] text-white" : "text-[#0B0B0C]/70 hover:bg-[#F4F5F7]"
                }`
              }
            >
              <n.icon size={18} /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-[#E2E8F0] space-y-1">
          <a href="/" target="_blank" rel="noreferrer" className="flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-[#0B0B0C]/70 hover:bg-[#F4F5F7]">
            <ExternalLink size={18} /> Bekijk site
          </a>
          <button onClick={doLogout} data-testid="admin-logout" className="w-full flex items-center gap-3 px-4 py-2.5 rounded-md text-sm text-red-600 hover:bg-red-50">
            <LogOut size={18} /> Uitloggen
          </button>
        </div>
      </aside>
      <main className="flex-1 ml-64 p-8 lg:p-12">
        <div className="mb-8 flex items-center justify-between">
          <div />
          <p className="text-sm text-[#0B0B0C]/60">Ingelogd als <b>{user?.email}</b></p>
        </div>
        <Outlet />
      </main>
    </div>
  );
}
